import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import { DEFAULT_LOCALE, LOCALE_CODES } from './locales'

// One JSON file per language and namespace: src/locales/<lang>/<ns>.json
// They are code-split by Vite and loaded on demand.
const files = import.meta.glob('../locales/*/*.json')

export const NAMESPACES = [
  'common', 'home', 'features', 'compare', 'pricing', 'download', 'contact',
  'about', 'blog', 'careers', 'press', 'help', 'docs', 'community', 'privacy',
  'terms', 'security', 'cookies', 'enterprise', 'partners', 'status', 'changelog',
] as const

i18n
  .use(
    resourcesToBackend(async (lng: string, ns: string) => {
      const loader = files[`../locales/${lng}/${ns}.json`]
      if (!loader) return {}
      const mod = (await loader()) as { default: Record<string, unknown> }
      return mod.default
    }),
  )
  .use(initReactI18next)
  .init({
    lng: DEFAULT_LOCALE,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: LOCALE_CODES,
    ns: [...NAMESPACES],
    defaultNS: 'common',
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    returnNull: false,
  })

export default i18n
